import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// Importez tous vos composants de pages
import Home from "./pages/Home";
import Courses from "./pages/courses";
import Registration from "./pages/registration";
import CourseDetails from "./pages/courseDetails";
import Login from "./pages/Login";
import Footer from "./pages/footer";
import NaveBare from "./pages/naveBare";
import Cours from "./pages/cours";
import Reservations from "./pages/Reservations";
import FormationSurMesure from "./pages/FormationSurMesure";
import CertificateDetail from "./pages/CertificateDetail"; // Correction de la casse
import "./utils/webAxios";
import { HelmetProvider } from "react-helmet-async";

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div>
          <NaveBare />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/courses" element={<Courses />} />
            {/* <Route path="/registration" element={<Registration />} /> */}
            <Route path="/registration/:id" element={<Registration />} />
            <Route path="/cours" element={<Cours />} />
            <Route path="/login" element={<Login />} />
            <Route path="/course-details/:id" element={<CourseDetails />} />
            <Route
              path="/reservations/:id_formation/:id_groupe"
              element={<Reservations />}
            />
            <Route
              path="/formation-sur-mesure"
              element={<FormationSurMesure />}
            />
            <Route
              path="/certificate-detail/:id"
              element={<CertificateDetail />}
            />
            {/* <Route path="/demande-formation" element={<FormationSurMesure />} /> */}
          </Routes>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
